export default __webpack_public_path__ + "static/media/Molecular.844c60df.png";